import clsx from 'clsx'
import { ReactElement, ReactNode } from 'react'
import React from 'react'

import s from './styles.module.scss'

import { IconSvg } from '../../../atoms'

export interface ITitle {
  label: string | ReactElement
  align: 'center' | 'left'
  onClickViewMore?: () => void
  className?: string
  exploreMoreLabel?: ReactNode
}

interface IUsedHomeAlternativeTitle extends ITitle {
  style?: React.CSSProperties
  dataGtm?: string
}

const Title = ({
  label,
  align,
  style = {},
  className,
  exploreMoreLabel,
  onClickViewMore,
}: IUsedHomeAlternativeTitle) => {
  return (
    <div
      className={clsx(
        s.containerTitle,
        { [s.center]: align === 'center', [s.left]: align === 'left' },
        className,
      )}
      style={style}
    >
      <h2 className={s.name}>{label}</h2>
      {onClickViewMore && exploreMoreLabel && (
        <div
          data-gtm={`_explorer${label.toString().toLowerCase().replace(/[ '-]/gi, '_')}_explorer`}
          className={s.viewMore}
          onClick={onClickViewMore}
        >
          <span className={s.explore}>{exploreMoreLabel}</span>{' '}
          <IconSvg.ArrowRight color='currentColor' />
        </div>
      )}
    </div>
  )
}

export default Title
